export enum VenmoFormInputNames {
  VenmoAddress = 'venmoValue',
}
